<div class="container">
  <!-- Skeleton para el título -->
  <h1 *ngIf="isLoading" class="skeleton-title"></h1>
  <h1 *ngIf="!isLoading" class="flex flex-col text-center items-center font-bold my-10">
    {{ title }}
  </h1>

  <section class="flex flex-col items-center">
    <div
      class="content-wrapper flex flex-col-reverse xl:flex-row items-center xl:items-start justify-center w-full gap-8">

      <!-- Skeleton Loader -->
      <div *ngIf="isLoading" class="skeleton-wrapper flex flex-col gap-4">
        <div class="skeleton-row"></div>
        <div class="skeleton-row"></div>
        <div class="skeleton-row"></div>
        <div class="skeleton-row"></div>
        <div class="skeleton-row short"></div>
        <div class="w-full flex justify-center">
          <div class="skeleton-button"></div>
        </div>
      </div>

      <!-- Contenido real -->
      <div *ngIf="!isLoading" class="flex flex-col gap-4">
        <span class="text-content max-w-xl" [innerHTML]="content"></span>
        <div class="w-full flex justify-center">
          <button (click)="navigate()"
                  [ngClass]="isNavigated ? 'pl-6 pr-3 opacity-50 cursor-not-allowed' : 'px-6'"
                  class="bg-yellow-#FF6D03 font-Lato-Regular text-white flex items-center text-center
                                   w-auto max-w-[300px] h-10 lg:h-[49px] rounded-3xl text-md lg:text-[19px] justify-center">
            <p>{{ 'PARTICIPATE_NOW' | translate }}</p>
            <fa-icon *ngIf="isNavigated"
                     class="relative flex justify-center items-center animate-spin rounded-full w-9 h-9 text-xl text-white"
                     [icon]="faSpinner">
            </fa-icon>
          </button>
        </div>
<!--        <div *ngIf="winnersList?.length !== 0">-->
<!--          <h1 class="text-lg font-bold text-center text-gray-800 pt-5">{{ 'WINNERS' | translate }}</h1>-->
<!--          <h1 class="text-lg font-bold text-center text-gray-800">{{ 'WINNERS_MORE_RECENT' | translate : {initialDate: initialDate, finalDate: finalDate} }}</h1>-->
<!--          <ul class="list-disc list-inside bg-gray-100 p-4 rounded-lg shadow-md text-gray-700 text-left justify-start">-->
<!--            <li *ngFor="let winner of winnersList" class="py-1">{{ winner }}</li>-->
<!--          </ul>-->
<!--        </div>-->
      </div>

      <!-- Skeleton Image -->
      <div *ngIf="isLoading" class="skeleton-image"></div>

      <img *ngIf="!isLoading" class="image" src="assets/imgs/giveaway_img.png" alt="giveaway_img">
    </div>
  </section>
</div>
